export default __webpack_public_path__ + "static/media/transfer-old-bibly-4.0ff47637.png";